import { get } from "./api";

export async function getHosts() {
  const { data } = await get("comet/host");
  return data;
}
